const SimpleReducer = (state, { key, value, batch, hardSet, log }) => {
  if (key) {
    let _s = state;
    const keyChain = key.split('.');
    const mainKey = keyChain.pop();
    for (const key of keyChain) {
      if (!_s.hasOwnProperty(key)) {
        _[key] = {};
      }
      _s = _s[key];
    }
    _s[mainKey] = value;
    state.hasChanged = true;
  } else if (batch) {
    for (const transaction of batch) {
      let _s = state;
      const keyChain = transaction.key.split('.');
      const mainKey = keyChain.pop();
      for (const key of keyChain) {
        if (!_s.hasOwnProperty(key)) {
          _[key] = {};
        }
        _s = _s[key];
      }
      _s[mainKey] = transaction.value;
    }
  } else if (hardSet) {
    for (const key in state) {
      delete state[key];
    }
    for (const key in hardSet) state[key] = hardSet[key];
  } else if (log) {
    let _d;
    if (log.keys) {
      _d = log.keys.reduce((pre, cur) => ({ ...pre, [cur]: state[cur] }), {});
    } else {
      _d = state;
    }
    // localStorage.setItem(
    //   log.name,
    //   JSON.stringify({
    //     state: _d,
    //     time: new Date().toLocaleString(),
    //   })
    // );
  }
};

export default SimpleReducer;
